// Port of api/fuel/app/classes/insights/game/affinity.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'affinity',
    priority: 2,
    requires: ['init'],
    insight: false,
    detail: ['affinity'],
    types: [Constants.TYPE_USER],
    run: function(type, owner, userIndex, detail, filter, vars) {

        var user_id = owner.get_id()
        var game_id = parseInt(vars.id, 10)
        var game = this._data.game

        if (!game) return {}

        // GAME ATTRIBUTES - single UNION ALL query for all 4 relation types
        var relRows = Util.queryFast(
            'SELECT "designer" AS rel, designer_id AS id FROM game_designer WHERE game_id = ' + game_id +
            ' UNION ALL ' +
            'SELECT "publisher" AS rel, publisher_id AS id FROM game_publisher WHERE game_id = ' + game_id + ' AND game_publisher_primary = 1 AND game_version_id = 0' +
            ' UNION ALL ' +
            'SELECT "mechanic" AS rel, mechanic_id AS id FROM game_mechanic WHERE game_id = ' + game_id +
            ' UNION ALL ' +
            'SELECT "category" AS rel, category_id AS id FROM game_category WHERE game_id = ' + game_id
        )

        var attrIds = { designer: [], publisher: [], mechanic: [], category: [] }

        for (var ri = 0; ri < relRows.length; ri++) {
            attrIds[relRows[ri].rel].push(parseInt(relRows[ri].id, 10))
        }

        var hasAny = attrIds.designer.length || attrIds.publisher.length || attrIds.mechanic.length || attrIds.category.length

        if (!hasAny) return { affinity: { attributes: [], baselines: null } }

        // NAME LOOKUPS
        var nameMap = { designer: {}, publisher: {}, mechanic: {}, category: {} }
        var nameParts = []

        if (attrIds.designer.length) nameParts.push('SELECT "designer" AS t, designer_id AS id, designer_name AS name FROM designer WHERE designer_id IN(' + Util.in(attrIds.designer) + ')')
        if (attrIds.publisher.length) nameParts.push('SELECT "publisher" AS t, publisher_id AS id, publisher_name AS name FROM publisher WHERE publisher_id IN(' + Util.in(attrIds.publisher) + ')')
        if (attrIds.mechanic.length) nameParts.push('SELECT "mechanic" AS t, mechanic_id AS id, mechanic_name AS name FROM mechanic WHERE mechanic_id IN(' + Util.in(attrIds.mechanic) + ')')
        if (attrIds.category.length) nameParts.push('SELECT "category" AS t, category_id AS id, category_name AS name FROM category WHERE category_id IN(' + Util.in(attrIds.category) + ')')

        var nameRows = Util.queryFast(nameParts.join(' UNION ALL '))
        for (var ni = 0; ni < nameRows.length; ni++) {
            nameMap[nameRows[ni].t][parseInt(nameRows[ni].id, 10)] = nameRows[ni].name
        }

        // USER'S GAME UNIVERSE
        var universeIds = this._data.universe_ids
        if (!universeIds.length) return { affinity: { attributes: [], baselines: null } }
        var universeIn = Util.in(universeIds)

        // PER-GAME DATA
        var ratingRows = Util.queryFast('SELECT game_id, rating_value AS rating FROM rating WHERE user_id = ' + user_id + ' AND rating_value > 0')
        var gameRatings = {}
        for (var rri = 0; rri < ratingRows.length; rri++) gameRatings[parseInt(ratingRows[rri].game_id, 10)] = parseFloat(ratingRows[rri].rating)

        var playRows = Util.queryFast('SELECT game_id, SUM(play_count) AS plays FROM play WHERE user_id = ' + user_id + ' GROUP BY game_id')
        var gamePlays = {}
        for (var pri = 0; pri < playRows.length; pri++) gamePlays[parseInt(playRows[pri].game_id, 10)] = parseInt(playRows[pri].plays, 10)

        // Ownership duration
        var ownershipRows = Util.queryFast(
            'SELECT game_id, log_context, log_date FROM log_user_collection_status ' +
            'WHERE user_id = ' + user_id + ' AND log_status = ' + Constants.COLLECTION_STATUS_OWN + ' ORDER BY game_id, log_date ASC'
        )

        var ownershipEvents = {}
        for (var oi = 0; oi < ownershipRows.length; oi++) {
            var gid = parseInt(ownershipRows[oi].game_id, 10)
            if (!ownershipEvents[gid]) ownershipEvents[gid] = []
            ownershipEvents[gid].push({ context: parseInt(ownershipRows[oi].log_context, 10), date: parseInt(ownershipRows[oi].log_date, 10) })
        }

        var currentlyOwned = {}
        var ownedRows = Util.queryFast('SELECT game_id FROM collection WHERE user_id = ' + user_id + ' AND collection_own = 1')
        for (var co = 0; co < ownedRows.length; co++) currentlyOwned[parseInt(ownedRows[co].game_id, 10)] = true

        var now = Util.time()
        var gameDuration = {}

        var oeKeys = Object.keys(ownershipEvents)
        for (var oei = 0; oei < oeKeys.length; oei++) {
            var oeGid = parseInt(oeKeys[oei], 10)
            var events = ownershipEvents[oeGid]
            var totalDays = 0
            var addDate = null

            for (var ei = 0; ei < events.length; ei++) {
                if (events[ei].context === Constants.LOG_CONTEXT_ADDED) {
                    addDate = events[ei].date
                } else if (events[ei].context === Constants.LOG_CONTEXT_REMOVED && addDate !== null) {
                    totalDays += Math.max(1, Math.ceil((events[ei].date - addDate) / Constants.TIME_DAY))
                    addDate = null
                }
            }

            if (addDate !== null && currentlyOwned[oeGid]) {
                totalDays += Math.max(1, Math.ceil((now - addDate) / Constants.TIME_DAY))
            }

            if (totalDays > 0) gameDuration[oeGid] = totalDays
        }

        // BASELINES
        var ratedValues = [], playedValues = [], durationValues = []
        var grKeys = Object.keys(gameRatings)
        for (var gri2 = 0; gri2 < grKeys.length; gri2++) ratedValues.push(gameRatings[grKeys[gri2]])
        var gpKeys = Object.keys(gamePlays)
        for (var gpi = 0; gpi < gpKeys.length; gpi++) playedValues.push(gamePlays[gpKeys[gpi]])
        var gdKeys = Object.keys(gameDuration)
        for (var gdi = 0; gdi < gdKeys.length; gdi++) durationValues.push(gameDuration[gdKeys[gdi]])

        var baselineRating = ratedValues.length ? ratedValues.reduce(function(a, b) { return a + b }, 0) / ratedValues.length : 0
        var baselinePlays = playedValues.length ? playedValues.reduce(function(a, b) { return a + b }, 0) / playedValues.length : 0
        var baselineDuration = durationValues.length ? durationValues.reduce(function(a, b) { return a + b }, 0) / durationValues.length : 0

        // ATTRIBUTE GAME SETS
        var attrGameSets = {}

        var joinTables = {
            designer: { table: 'game_designer', col: 'designer_id' },
            publisher: { table: 'game_publisher', col: 'publisher_id' },
            mechanic: { table: 'game_mechanic', col: 'mechanic_id' },
            category: { table: 'game_category', col: 'category_id' }
        }

        var attrTypes = ['designer', 'publisher', 'mechanic', 'category']
        for (var ati = 0; ati < attrTypes.length; ati++) {
            var attrType = attrTypes[ati]
            if (!attrIds[attrType].length) continue

            var cfg = joinTables[attrType]
            var extra = (attrType === 'publisher') ? ' AND game_publisher_primary = 1 AND game_version_id = 0' : ''

            var rows = Util.queryFast(
                'SELECT ' + cfg.col + ' AS attr_id, game_id FROM ' + cfg.table +
                ' WHERE ' + cfg.col + ' IN(' + Util.in(attrIds[attrType]) + ') AND game_id IN(' + universeIn + ')' + extra
            )

            for (var ari = 0; ari < rows.length; ari++) {
                var key = attrType + '_' + rows[ari].attr_id
                if (!attrGameSets[key]) attrGameSets[key] = { type: attrType, id: parseInt(rows[ari].attr_id, 10), games: [] }
                attrGameSets[key].games.push(parseInt(rows[ari].game_id, 10))
            }
        }

        // COMPUTE AFFINITY PER ATTRIBUTE
        var thisRating = gameRatings[game_id] !== undefined ? gameRatings[game_id] : null
        var thisPlays = gamePlays[game_id] !== undefined ? gamePlays[game_id] : 0

        var attributes = []
        var totalAttributes = 0

        var agsKeys = Object.keys(attrGameSets)
        for (var agsi = 0; agsi < agsKeys.length; agsi++) {
            var set = attrGameSets[agsKeys[agsi]]
            var setType = set.type
            var attrId = set.id
            var gameIds = set.games
            var gameCount = gameIds.length
            totalAttributes++

            // Rating signal
            var attrRatings = []
            var attrRatingsByGame = {}
            for (var ari2 = 0; ari2 < gameIds.length; ari2++) {
                if (gameRatings[gameIds[ari2]] !== undefined) {
                    attrRatings.push(gameRatings[gameIds[ari2]])
                    attrRatingsByGame[gameIds[ari2]] = gameRatings[gameIds[ari2]]
                }
            }

            var avgRating = attrRatings.length ? attrRatings.reduce(function(a, b) { return a + b }, 0) / attrRatings.length : null
            var ratingDelta = (avgRating !== null && baselineRating > 0) ? Math.round((avgRating - baselineRating) * 100) / 100 : null

            // Play signal
            var attrPlays = []
            var attrPlaysByGame = {}
            for (var api = 0; api < gameIds.length; api++) {
                var p = gamePlays[gameIds[api]] !== undefined ? gamePlays[gameIds[api]] : 0
                attrPlays.push(p)
                attrPlaysByGame[gameIds[api]] = p
            }

            var avgPlays = attrPlays.length ? attrPlays.reduce(function(a, b) { return a + b }, 0) / attrPlays.length : 0
            var playRatio = (baselinePlays > 0) ? Math.round((avgPlays / baselinePlays) * 100) / 100 : null

            // Retention signal
            var attrDurations = []
            for (var adi = 0; adi < gameIds.length; adi++) {
                if (gameDuration[gameIds[adi]] !== undefined) attrDurations.push(gameDuration[gameIds[adi]])
            }

            var avgDuration = attrDurations.length ? attrDurations.reduce(function(a, b) { return a + b }, 0) / attrDurations.length : null
            var durationRatio = (avgDuration !== null && baselineDuration > 0) ? Math.round((avgDuration / baselineDuration) * 100) / 100 : null

            // Composite score
            var score = 0
            var signals = 0

            if (ratingDelta !== null) {
                score += Math.max(-1, Math.min(1, ratingDelta / 3)) * 0.4
                signals++
            }
            if (playRatio !== null) {
                score += Math.max(-1, Math.min(1, playRatio - 1)) * 0.35
                signals++
            }
            if (durationRatio !== null) {
                score += Math.max(-1, Math.min(1, durationRatio - 1)) * 0.25
                signals++
            }

            var compositeScore = (signals > 0) ? Math.round(score * 100) : null
            var name = nameMap[setType][attrId] || 'Unknown'

            // Per-game positioning
            var gameRatingRank = null
            var gameRatingOf = null
            var gameRatingDelta = null

            if (thisRating !== null && Object.keys(attrRatingsByGame).length) {
                var sorted = Object.keys(attrRatingsByGame).sort(function(a, b) { return attrRatingsByGame[b] - attrRatingsByGame[a] })
                for (var sri = 0; sri < sorted.length; sri++) {
                    if (parseInt(sorted[sri], 10) === game_id) { gameRatingRank = sri + 1; break }
                }
                gameRatingOf = Object.keys(attrRatingsByGame).length
                gameRatingDelta = (avgRating !== null) ? Math.round((thisRating - avgRating) * 100) / 100 : null
            }

            var gamePlayRank = null
            var gamePlayOf = null

            if (thisPlays > 0 && Object.keys(attrPlaysByGame).length) {
                var sortedPlays = Object.keys(attrPlaysByGame).sort(function(a, b) { return attrPlaysByGame[b] - attrPlaysByGame[a] })
                for (var spi = 0; spi < sortedPlays.length; spi++) {
                    if (parseInt(sortedPlays[spi], 10) === game_id) { gamePlayRank = spi + 1; break }
                }
                gamePlayOf = Object.keys(attrPlaysByGame).length
            }

            attributes.push({
                type: setType,
                id: attrId,
                name: name,
                games: gameCount,
                rated: attrRatings.length,
                avgRating: avgRating !== null ? Math.round(avgRating * 10) / 10 : null,
                ratingDelta: ratingDelta,
                avgPlays: Math.round(avgPlays * 10) / 10,
                playRatio: playRatio,
                avgDuration: avgDuration !== null ? Math.round(avgDuration) : null,
                durationRatio: durationRatio,
                score: compositeScore,
                gameRatingRank: gameRatingRank,
                gameRatingOf: gameRatingOf,
                gameRatingDelta: gameRatingDelta,
                gamePlayRank: gamePlayRank,
                gamePlayOf: gamePlayOf
            })
        }

        // EXPLORATION
        var exploration = []

        for (var exi = 0; exi < attrTypes.length; exi++) {
            var exType = attrTypes[exi]
            if (!attrIds[exType].length) continue

            var exCfg = joinTables[exType]
            var exExtra = (exType === 'publisher') ? ' AND a.game_publisher_primary = 1 AND a.game_version_id = 0' : ''

            var totalRows = Util.queryFast(
                'SELECT a.' + exCfg.col + ' AS attr_id, COUNT(DISTINCT a.game_id) AS total ' +
                'FROM ' + exCfg.table + ' a JOIN game g ON g.game_id = a.game_id ' +
                'WHERE a.' + exCfg.col + ' IN(' + Util.in(attrIds[exType]) + ') AND g.game_type = ' + Constants.GAME_TYPE_BASE + exExtra +
                ' GROUP BY a.' + exCfg.col
            )

            for (var tri = 0; tri < totalRows.length; tri++) {
                var exKey = exType + '_' + totalRows[tri].attr_id
                var exAttrId = parseInt(totalRows[tri].attr_id, 10)
                var total = parseInt(totalRows[tri].total, 10)
                var tried = attrGameSets[exKey] ? attrGameSets[exKey].games.length : 0
                var exName = nameMap[exType][exAttrId] || 'Unknown'

                exploration.push({
                    type: exType,
                    id: exAttrId,
                    name: exName,
                    tried: tried,
                    total: total,
                    percent: total > 0 ? Math.round((tried / total) * 1000) / 10 : 0
                })
            }
        }

        exploration.sort(function(a, b) { return b.percent - a.percent })
        var explorationTotal = exploration.length
        exploration = exploration.slice(0, detail ? 100 : 5)

        // WIN RATE
        var winRows = Util.queryFast(
            'SELECT p.game_id, SUM(p.play_won) AS wins, SUM(p.play_count) AS total ' +
            'FROM play p WHERE p.user_id = ' + user_id + ' AND p.play_won IS NOT NULL AND p.game_id IN(' + universeIn + ') ' +
            'GROUP BY p.game_id'
        )

        var gameWins = {}
        var gameWinTotal = {}
        var overallWins = 0
        var overallTotal = 0

        for (var wri = 0; wri < winRows.length; wri++) {
            var wGid = parseInt(winRows[wri].game_id, 10)
            gameWins[wGid] = parseInt(winRows[wri].wins, 10)
            gameWinTotal[wGid] = parseInt(winRows[wri].total, 10)
            overallWins += parseInt(winRows[wri].wins, 10)
            overallTotal += parseInt(winRows[wri].total, 10)
        }

        var overallWinRate = overallTotal > 0 ? Math.round((overallWins / overallTotal) * 1000) / 10 : null

        var winRates = []

        for (var wsi = 0; wsi < agsKeys.length; wsi++) {
            var wSet = attrGameSets[agsKeys[wsi]]
            var attrWins = 0
            var attrTotal = 0

            for (var wgi = 0; wgi < wSet.games.length; wgi++) {
                if (gameWins[wSet.games[wgi]] !== undefined) {
                    attrWins += gameWins[wSet.games[wgi]]
                    attrTotal += gameWinTotal[wSet.games[wgi]]
                }
            }

            if (attrTotal === 0) continue

            var rate = Math.round((attrWins / attrTotal) * 1000) / 10
            var wName = nameMap[wSet.type][wSet.id] || 'Unknown'

            winRates.push({
                type: wSet.type,
                id: wSet.id,
                name: wName,
                wins: attrWins,
                total: attrTotal,
                rate: rate,
                delta: overallWinRate !== null ? Math.round((rate - overallWinRate) * 10) / 10 : null
            })
        }

        winRates.sort(function(a, b) {
            if (a.rate !== b.rate) return b.rate > a.rate ? 1 : -1
            return b.total - a.total
        })

        var winRatesTotal = winRates.length
        winRates = winRates.slice(0, detail ? 100 : 5)

        // SHARED DNA
        var overlap = {}

        for (var dni = 0; dni < agsKeys.length; dni++) {
            var dSet = attrGameSets[agsKeys[dni]]
            var dName = nameMap[dSet.type][dSet.id] || 'Unknown'

            for (var dgi = 0; dgi < dSet.games.length; dgi++) {
                var dgid2 = dSet.games[dgi]
                if (dgid2 === game_id) continue
                if (!overlap[dgid2]) overlap[dgid2] = { count: 0, shared: [] }
                overlap[dgid2].count++
                overlap[dgid2].shared.push(dName)
            }
        }

        // Sort by overlap count descending
        var overlapKeys = Object.keys(overlap).sort(function(a, b) { return overlap[b].count - overlap[a].count })

        var dnaLimit = detail ? 100 : 5
        var dnaTotal = overlapKeys.length
        var dna = []

        var dnaSlice = overlapKeys.slice(0, dnaLimit)
        for (var dsi = 0; dsi < dnaSlice.length; dsi++) {
            var dGid = parseInt(dnaSlice[dsi], 10)
            dna.push({
                id: dGid,
                overlap: overlap[dGid].count,
                total: totalAttributes,
                shared: overlap[dGid].shared,
                rating: gameRatings[dGid] !== undefined ? gameRatings[dGid] : null,
                plays: gamePlays[dGid] !== undefined ? gamePlays[dGid] : 0
            })
            this._references.games.push(dGid)
        }

        // GROUP BY TYPE
        var byType = { designer: [], publisher: [], mechanic: [], category: [] }
        for (var bti = 0; bti < attributes.length; bti++) {
            byType[attributes[bti].type].push(attributes[bti])
        }

        var sortFn = function(a, b) {
            if (a.score === null && b.score === null) return 0
            if (a.score === null) return 1
            if (b.score === null) return -1
            return b.score - a.score
        }

        var totals = {}
        var limit = detail ? 100 : 5

        for (var tyi = 0; tyi < attrTypes.length; tyi++) {
            var t = attrTypes[tyi]
            byType[t].sort(sortFn)
            totals[t] = byType[t].length
            byType[t] = byType[t].slice(0, limit)
        }

        var all = byType.designer.concat(byType.publisher, byType.mechanic, byType.category)
        all.sort(sortFn)

        return {
            affinity: {
                attributes: all,
                totals: totals,
                exploration: exploration,
                explorationTotal: explorationTotal,
                winRates: winRates,
                winRatesTotal: winRatesTotal,
                overallWinRate: overallWinRate,
                dna: dna,
                dnaTotal: dnaTotal,
                baselines: {
                    rating: Math.round(baselineRating * 100) / 100,
                    plays: Math.round(baselinePlays * 10) / 10,
                    duration: Math.round(baselineDuration)
                }
            }
        }

    }
})
